export const SEO_SITE_OPTIONS = [
  { value: '', label: 'All sites' },
  { value: 'airport-transfers-taxi', label: 'Airport Transfers Taxi' },
  { value: 'uk-airport-taxi', label: 'UK Airport Taxi Transfers' },
  { value: 'southampton-port-taxi', label: 'Southampton Port Taxi' },
  { value: 'liverpool-dock-taxi', label: 'Liverpool Docks Taxi' },
] as const;

export type SeoRouteRecord = {
  id: string;
  siteKey: string;
  routeSlug: string;
  path: string;
  published: boolean;
  sortOrder: number;
  from: { slug: string; name: string; placeType: string };
  to: { slug: string; name: string; placeType: string };
  seo: {
    metaTitle: string;
    metaDescription: string;
    h1: string;
    intro: string;
    keywords: string[];
    distanceMiles: number;
    driveLabel: string;
  };
};

export function siteLabel(siteKey: string): string {
  return SEO_SITE_OPTIONS.find((s) => s.value === siteKey)?.label ?? siteKey;
}
